import { render, staticRenderFns } from "./airPay.vue?vue&type=template&id=4509e78c&scoped=true&"
import script from "./airPay.vue?vue&type=script&lang=js&"
export * from "./airPay.vue?vue&type=script&lang=js&"
import style0 from "./airPay.vue?vue&type=style&index=0&id=4509e78c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509e78c",
  null
  
)

export default component.exports